import { useState, useEffect } from 'react';
import './CuratorModal.css';

const EMPTY = {
  name: '',
  handle: '',
  tag: 'EARLY_BUYER',
  prix: '',
  solde: '',
  couverture: '0',
  tauxMigration: '0',
  roiScore: '',
  abonnes: 0,
  touxResultat24h: '0',
  tous24h: 0,
};

export default function CuratorModal({ curator, onSave, onClose }) {
  const editing = !!curator;
  const [form, setForm] = useState(editing ? { ...curator } : EMPTY);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    setForm(editing ? { ...curator } : EMPTY);
    setErrors({});
  }, [curator, editing]);

  const set = (key, val) => {
    setForm(f => ({ ...f, [key]: val }));
    setErrors(e => ({ ...e, [key]: '' }));
  };

  const validate = () => {
    const e = {};
    if (!form.name.trim())   e.name   = 'Nom requis';
    if (!form.handle.trim()) e.handle = 'Handle requis';
    if (!form.prix || isNaN(form.prix) || +form.prix < 0) e.prix = 'Prix invalide (ex: 20)';
    if (!form.solde || isNaN(form.solde))                  e.solde = 'Solde invalide (ex: 1.66)';
    if (!form.roiScore || isNaN(form.roiScore))            e.roiScore = 'Score invalide (ex: 3)';
    return e;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const errs = validate();
    if (Object.keys(errs).length > 0) { setErrors(errs); return; }
    const handle = form.handle.startsWith('@') ? form.handle : '@' + form.handle;
    onSave({
      ...form,
      handle,
      prix:       parseFloat(form.prix),
      roiScore:   parseInt(form.roiScore),
      avatar:     form.name.charAt(0).toUpperCase(),
      avatarColor: editing ? form.avatarColor : randomColor(),
    });
  };

  return (
    <div className="cm-overlay" onClick={onClose}>
      <div className="cm-panel" onClick={e => e.stopPropagation()}>

        {/* Header */}
        <div className="cm-header">
          <div className="cm-title">
            {editing ? 'Modifier le curateur' : 'Ajouter un curateur'}
          </div>
          <button className="cm-close" onClick={onClose}>
            <svg viewBox="0 0 14 14" fill="none" width="14" height="14">
              <path d="M2 2l10 10M12 2L2 12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
            </svg>
          </button>
        </div>

        <form onSubmit={handleSubmit} className="cm-form">

          {/* Nom */}
          <div className="cm-field">
            <label className="cm-label">NOM DU CURATEUR</label>
            <input
              className={`cm-input ${errors.name ? 'error' : ''}`}
              value={form.name}
              onChange={e => set('name', e.target.value)}
              placeholder="ex: DEGEN #1"
            />
            {errors.name && <span className="cm-error">{errors.name}</span>}
          </div>

          {/* Handle */}
          <div className="cm-field">
            <label className="cm-label">HANDLE</label>
            <input
              className={`cm-input ${errors.handle ? 'error' : ''}`}
              value={form.handle}
              onChange={e => set('handle', e.target.value)}
              placeholder="@pseudo"
            />
            {errors.handle && <span className="cm-error">{errors.handle}</span>}
          </div>

          {/* Tag */}
          <div className="cm-field">
            <label className="cm-label">TYPE DE CURATEUR</label>
            <div className="cm-tag-group">
              {[
                ['EARLY_BUYER',  'Acheteur précoce'],
                ['GROS_WALLET',  'Gros portefeuille'],
                ['ACCUMULATEUR', 'Accumulateur'],
              ].map(([val, label]) => (
                <button
                  type="button"
                  key={val}
                  className={`cm-tag-btn ${form.tag === val ? 'active' : ''}`}
                  onClick={() => set('tag', val)}
                >
                  {label}
                </button>
              ))}
            </div>
          </div>

          {/* Row: Prix + ROI */}
          <div className="cm-row">
            <div className="cm-field">
              <label className="cm-label">PRIX (%)</label>
              <input
                className={`cm-input ${errors.prix ? 'error' : ''}`}
                value={form.prix}
                onChange={e => set('prix', e.target.value)}
                placeholder="20"
                type="number" min="0" step="0.1"
              />
              {errors.prix && <span className="cm-error">{errors.prix}</span>}
            </div>
            <div className="cm-field">
              <label className="cm-label">SCORE ROI</label>
              <input
                className={`cm-input ${errors.roiScore ? 'error' : ''}`}
                value={form.roiScore}
                onChange={e => set('roiScore', e.target.value)}
                placeholder="3"
                type="number" min="0"
              />
              {errors.roiScore && <span className="cm-error">{errors.roiScore}</span>}
            </div>
          </div>

          {/* Row: Solde + Couverture */}
          <div className="cm-row">
            <div className="cm-field">
              <label className="cm-label">SOLDE (SOL)</label>
              <input
                className={`cm-input ${errors.solde ? 'error' : ''}`}
                value={form.solde}
                onChange={e => set('solde', e.target.value)}
                placeholder="1.66"
                type="number" min="0" step="0.01"
              />
              {errors.solde && <span className="cm-error">{errors.solde}</span>}
            </div>
            <div className="cm-field">
              <label className="cm-label">COUVERTURE (%)</label>
              <input
                className="cm-input"
                value={form.couverture}
                onChange={e => set('couverture', e.target.value)}
                placeholder="0"
                type="number" min="0" max="100"
              />
            </div>
          </div>

          {/* Taux migration */}
          <div className="cm-field">
            <label className="cm-label">TAUX DE MIGRATION (%)</label>
            <input
              className="cm-input"
              value={form.tauxMigration}
              onChange={e => set('tauxMigration', e.target.value)}
              placeholder="0.8"
              type="number" min="0" step="0.1"
            />
          </div>

          {/* Boutons */}
          <div className="cm-actions">
            <button type="button" className="cm-btn-cancel" onClick={onClose}>
              Annuler
            </button>
            <button type="submit" className="cm-btn-save">
              {editing ? 'Enregistrer' : 'Ajouter au fil'}
            </button>
          </div>

        </form>
      </div>
    </div>
  );
}

const COLORS = ['#1a3a5a','#2a1a4a','#1a3a2a','#3a2a1a','#1a2a3a','#2a3a1a','#3a1a2a'];
const randomColor = () => COLORS[Math.floor(Math.random() * COLORS.length)];
